export default __webpack_public_path__ + "static/media/UNDP_White_Footer_EN.9a5f69e8.svg";